import { render, staticRenderFns } from "./FullTimeTab.htm?vue&type=template&id=081f1d2f&scoped=true&"
import script from "./FullTimeTab.ts?vue&type=script&lang=js&"
export * from "./FullTimeTab.ts?vue&type=script&lang=js&"
import style0 from "../ChatRoomsTab.scss?vue&type=style&index=0&id=081f1d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f1d2f",
  null
  
)

export default component.exports